export default __webpack_public_path__ + "159c7dac6df4a58df4186596f5afbf31.svg";